"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Tag = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 20,
  height: 16,
  viewBox: "0 0 20 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M1 3v4.172a2 2 0 00.586 1.414l5.71 5.71a2.41 2.41 0 003.408 0l3.592-3.592a2.41 2.41 0 000-3.408l-5.71-5.71A2 2 0 007.172 1H3a2 2 0 00-2 2z",
  stroke: "#ACB3BE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "stroke",
  d: "M16 14l1.592-1.592a4.82 4.82 0 000-6.816L13 1M5 5h-.01",
  stroke: "#ACB3BE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _default = Tag;
exports.default = _default;